<template>
  <div class="boxS">
    <div class="title" style="margin-top:5px">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>访客管理</el-breadcrumb-item>
        <el-breadcrumb-item>通行记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="box">
      <div class="box-title">
        <el-select clearable style="margin:0 16px 0 0px" @change="getData()" v-model="projectName" placeholder="项目名称">
          <el-option v-for="item in projects" :key="item.id" :label="item.name" :value="item.name">
          </el-option>
        </el-select>
        <el-date-picker
        style="margin:0 30px 0 16px"
          type="date"
          value-format="yyyy-MM-dd"
          v-model="date"
          :clearable="false"
          placeholder="日期"
          @change="getData()">
        </el-date-picker>
        <el-button type="primary">查询</el-button>
      </div>
      <el-table
        :data="tableData"
        border
        :header-cell-style="tableHeadStyle"
        height="67vh"
        style="width: 100%">
        <el-table-column
          label="序号"
          width="180">
          <template slot-scope="scope">
            <span>{{(pageNum-1)*pageSize+scope.$index+1}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="项目名称"
          width="490">
          <template slot-scope="scope">
            <span>{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="总通行人次">
          <template slot-scope="scope">
            <span>
              {{scope.row.statistics.punchCount||0}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="正常人次">
          <template slot-scope="scope">
            <span @click="enter(scope.row,2)" style="color:#358ADA;text-decoration:underline;cursor: pointer;">
              {{scope.row.statistics.normalCount||0}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="异常人次">
          <template slot-scope="scope">
            <span @click="enter(scope.row,1)" :style="scope.row.statistics.abnormalCount>0?'color:#FF0000;text-decoration:underline;cursor: pointer;':'color:#358ADA;text-decoration:underline;cursor: pointer;'">
              {{scope.row.statistics.abnormalCount||0}}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
  export default {
    data() {
      return {
        pageSize: 20,
        pageNum:1,
        total:0,
        tableData:[],
        entId:'',
        date:'',
        projectName:'',
        projects:[]
      }
    },
    mounted(){
      this.entId = util.session.get('groupId')
      this.date= util.myTime.getCurTime()
      this.getData()
      this.getAll()
    },
    methods:{
      enter(item,index){
        let that=this
        console.log(item)
        this.$router.push({
          path:'/visitorRecordListData',
          query:{
            flag:index,
            projectId:item.projectId,
            date:that.date,
            name:item.name
          }
        })
      },
      getAll() {
        var that = this
        myHttp
          .getProjectListByEntIdAndJoinType({
            entId: util.session.get('groupId'),
            // joinType: this.search.joinType
          })
          .then(function(resp) {
            if (resp.data.code == '200') {
              var list = resp.data.data.list || []
              that.projects = list
            }
          })
      },
      tableHeadStyle({ row, column, rowIndex, columnIndex }){
        if(rowIndex == 0){
          return `background-color: #EEE;`
        }
      },
      getData(){
        myHttp.findStrangerDayHealthStatistics({
          pageSize:this.pageSize,
          pageNum:this.pageNum,
          entId: this.entId,
          projectName:this.projectName,
          date:this.date
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.tableData = res.data.data.projectEntList.list
            this.total = res.data.data.projectEntList.total
          }
        })
      },
      handleSizeChange(val){
        this.pageSize = val
        this.pageNum = 1
        this.getData()
      },
      handleCurrentChange(val){
        this.pageNum = val
        this.getData()
      }
    }
  }
</script>

<style scoped>
::v-deep .cell>div{
  font-size: .7292vw;
  text-align: start;
}
::v-deep .cell{
  font-size: .7292vw !important;
  text-align: start !important;
}
.boxS{
  padding: 0 1.25vw 0 .4167vw;
}

 .title{
  padding: 0 .4167vw;
}
.box{
  padding: 0 .4167vw;
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 5px 4px 10px -2px rgba(0, 0, 0, 0.25);
}
.box-title{
  height: 6vh;
  display: flex;
  align-items: center;
  justify-content: start;
}
</style>